// extracted by mini-css-extract-plugin
export default {"badge":"comment-badge_badge__di8PO","badge_count":"comment-badge_badge_count__yRAnO","badge_icon":"comment-badge_badge_icon__rMEy9"};